var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "columns is-gapless" }, [
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "field is-horizontal" }, [
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field-body" }, [
                  _c("div", { staticClass: "field has-addons" }, [
                    _c(
                      "div",
                      { staticClass: "control has-icons-left has-icons-right" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filter.query,
                              expression: "filter.query",
                            },
                          ],
                          staticClass: "input",
                          attrs: {
                            type: "text",
                            placeholder: "Start typing to filter",
                          },
                          domProps: { value: _vm.filter.query },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.filter,
                                  "query",
                                  $event.target.value
                                )
                              },
                              _vm.search,
                            ],
                          },
                        }),
                        _vm._m(0),
                      ]
                    ),
                    _c("div", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button is-primary is-outlined tooltip",
                          attrs: { "data-tooltip": "Reset search" },
                          on: {
                            click: function ($event) {
                              return _vm.reset()
                            },
                          },
                        },
                        [_vm._m(1)]
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "control is-pulled-right" }, [
              _c(
                "div",
                {
                  staticClass: "select",
                  on: {
                    change: function ($event) {
                      return _vm.getAvailableMiscs()
                    },
                  },
                },
                [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.activeTab,
                          expression: "activeTab",
                        },
                      ],
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.activeTab = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    [
                      _c(
                        "option",
                        {
                          domProps: {
                            value:
                              _vm.labourType.toUpperCase() ===
                              _vm.availableMiscTypes.emta.toUpperCase()
                                ? _vm.availableMiscTypes.emta
                                : _vm.availableMiscTypes.standard,
                          },
                        },
                        [_vm._v("Standard")]
                      ),
                      _c(
                        "option",
                        { domProps: { value: _vm.availableMiscTypes.custom } },
                        [_vm._v("Custom")]
                      ),
                      _c(
                        "option",
                        {
                          domProps: {
                            value: _vm.availableMiscTypes.emtasundry,
                          },
                        },
                        [_vm._v("e-MTA Sundry")]
                      ),
                      _vm.$userInfo &&
                      _vm.$userInfo.countryCode.localeCompare(
                        "NZ",
                        _vm.$userInfo.locale,
                        { sensitivity: "accent" }
                      ) === 0
                        ? _c(
                            "option",
                            {
                              domProps: {
                                value: _vm.availableMiscTypes.veronz,
                              },
                            },
                            [_vm._v("Vero-NZ")]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
      _c(
        "bulma-table",
        {
          staticClass: "table is-bordered is-striped is-narrow is-fullwidth",
          attrs: {
            columns: _vm.columns,
            "page-index": _vm.filter.pageIndex,
            "page-size": _vm.filter.pageSize,
            "total-rows": _vm.totalRows,
            "is-loading": _vm.isTableLoading,
            "sort-column": _vm.filter.sortColumn,
            "sort-order": _vm.filter.sortOrder,
          },
          on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
        },
        [
          _vm._l(_vm.availableItems, function (item, index) {
            return _c(
              "tr",
              {
                key: index,
                class: { "is-selected": _vm.selectedRow === index },
                on: {
                  dblclick: function ($event) {
                    return _vm.addNewItem(item, index)
                  },
                  click: function ($event) {
                    return _vm.highlightSelected(index, $event)
                  },
                },
              },
              [
                _c("td", [_vm._v(_vm._s(item.itemNo))]),
                _c("td", [_vm._v(_vm._s(item.description))]),
                _c("td", { staticClass: "has-text-right" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$filters.formatNumber(
                        item.price,
                        _vm.$userInfo.locale
                      )
                    )
                  ),
                ]),
                _c(
                  "td",
                  {
                    staticClass:
                      "has-vertical-middle has-text-centered is-content-width",
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "button is-primary is-small is-inverted",
                        on: {
                          click: function ($event) {
                            return _vm.addNewItem(item, index)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "icon is-medium" }, [
                          _c("i", { staticClass: "mdi mdi-plus mdi-24px" }),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            )
          }),
          _c("template", { slot: "empty" }, [
            _c("section", { staticClass: "section" }, [
              _c(
                "div",
                { staticClass: "content has-text-grey has-text-centered" },
                [
                  _c("span", { attrs: { icon: "icon is-large" } }, [
                    _c("i", { staticClass: "mdi mdi-48px mdi-emoticon-sad" }),
                  ]),
                  _c("p", [_vm._v("Nothing")]),
                ]
              ),
            ]),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-left" }, [
      _c("i", { staticClass: "mdi mdi-magnify mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }